import React, {useState} from 'react';
import {Box, Button, IconButton, Tooltip, Typography,
    Dialog, DialogActions, DialogContent, DialogTitle, InputLabel} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import {COLORS} from '../styles/styleConstants';

//import {useGridViewState} from '../hooks/useGridViewState';
import PropTypes from 'prop-types';
import AddButton from './addButton';
import Spacer from './spacer';
import {ClearFiltersButton} from './clearFiltersButton';

const ListPageHeader = (props)=> {

  // console.log('props');
  // console.log(props);

  const [openSearch, setOpenSearch] = useState(false);
  const [searchText, setSearchText] = useState('');

  let header = props.header;
  if(props.totalItems) {
    header = `${header} (${props.totalItems})`;
  }

  const handleSearchOpen = () => {
    setSearchText('');
    setOpenSearch(true);
  }
  const handleSearchClose = () => setOpenSearch(false);

  const handleTurnOffSearch = () => {
    if (props.turnOffSearch) {
      props.turnOffSearch();
    }
  }

  const handleSearch = () => {

    if (props.createFilterForSearchText && searchText.length > 2) {
      props.createFilterForSearchText(searchText);
    }
    handleSearchClose();
  }

  return (
    <Box display={'flex'} justifyContent={'space-between'} width={'100%'} alignItems={'center'}>
      {props.header && <Box>
        <Typography variant={'h4'}>{header}</Typography>
      </Box>}
      <Box display={'flex'}>
        {props.headComponent && props.headComponent} 
        {props.additionalButtons && props.additionalButtons.length > 0 &&
        <Box display={'flex'} alignItems={'center'}  >
          <Spacer x={4}  />
          {props.additionalButtons.map((button, index) => {
            const btn = <Button key={index+button.label}
              onClick={button.onClick}
              variant={button.variant}
              color={button.color}
              sx={{
                textTransform: 'uppercase',
                lineHeight: '16px',
              }}
            >{button.label}</Button>;

            return <div key={index}><Spacer x={3} />
              {button.tooltip ? <Tooltip title={button.tooltip}><span>{btn}</span></Tooltip> : btn}
              &nbsp;</div>;
          })
          }
        </Box>}
      </Box>
      <Box display={'flex'} alignItems={'center'}>
        <ClearFiltersButton
          viewController={props.viewController}
          extendedFilters={props.extendedFilters}
        />
        {props.children}
        {props.showAddButton && <AddButton action={props.addHandler}/>}
        {props.createFilterForSearchText && 
        <IconButton
          aria-label="search"
          color="primary"         // or "secondary", "inherit", etc.
          size="large"            // or "small", "medium"
          onClick={handleSearchOpen}
        >
          <SearchIcon />
        </IconButton>}  
        {props.createFilterForSearchText && 
        <IconButton
          aria-label="refresh"
          color="primary"         // or "secondary", "inherit", etc.
          size="large"            // or "small", "medium"
          onClick={handleTurnOffSearch}
        >
          <RefreshIcon />
        </IconButton>}   
        <Dialog 
          open={openSearch} 
          onClose={handleSearchClose}
          PaperProps={{
            style: {
              position: 'absolute',
              top: 20,
              right: 20,
              margin: 0,
            },
          }}
        >
          <DialogTitle>Search</DialogTitle>
          <DialogContent>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <InputLabel shrink htmlFor={'search-text'}
                  required={false}
                  sx={{
                    fontSize: {xs: '12px', md: '14px'},
                    fontWeight: '900',
                    padding: '0px 30px 0 10px',
                    margin: '0 0 0 0',
                    textTransform: 'capitalize !important',
                    //transform: {xs: 'translate(10px, -2px)', md: 'translate(10px, -4px)'},
                    color: COLORS.globalBlue,
                    zIndex: 1
                  }}>
                  Search Text
              </InputLabel>
              <input autoFocus
                id="search-text"
                type="text"
                value={searchText}
                autoComplete="off" 
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={(e) => {
                   
                    if (e.key === 'Enter') {
                      e.preventDefault(); // Important
                      handleSearch();
                      handleSearchClose();
                    }
                  }}
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  width: '350px',
                  padding: '0 0.50rem',
                  margin: '0 -6px 0 0',
                  fontSize: '0.9rem',
                  height: '2.5rem',
                  boxSizing: 'border-box',
                }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleTurnOffSearch} variant="contained" color="primary">Turn off Search</Button>
            <Button onClick={handleSearchClose} variant="contained" color="primary">Cancel</Button>
            <Button onClick={handleSearch} variant="contained" collor="primary" 
                disabled={searchText.trim().length < 3}
            >Search</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>

  );
};

ListPageHeader.propTypes = {
  header: PropTypes.string,
  headComponent: PropTypes.node,
  /** The view's useGridViewState instance, for the clear filters control. */
  viewController: PropTypes.instanceOf(Object),
  /** The view's useFilter side panel, where it has one. */
  extendedFilters: PropTypes.instanceOf(Object),
  addHandler: PropTypes.func,
  showAddButton: PropTypes.bool,
  totalItems: PropTypes.number,
  additionalButtons: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    variant: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
  })),
};

ListPageHeader.defaultProps = {
  header: '',
  headComponent: null,
  viewController: undefined,
  extendedFilters: undefined,
  addHandler: null,
  showAddButton: false,
  totalItems: null,
  additionalButtons: [],
};

export default ListPageHeader;
